<h5 class="mb-2 font-medium">{{ 'my-home.my-top-instruments.headline' | transloco }}</h5>
<div class="nav nav-tabs">
  @for (segment of segments; track $index) {
    <div class="nav-item">
      <a
        class="nav-link cursor-pointer"
        [attr.data-zid]="'top-instruments-' + segment"
        [class.active]="topInstrumentsSelector === segment"
        (click)="changeSegment(segment)"
      >
        {{ 'my-home.my-top-instruments.nav.' + segment | transloco }}
      </a>
    </div>
  }
</div>
@if (topTrades[topInstrumentsSelector] | async; as list) {
  @if (list?.length) {
    @for (item of list; track item.isin; let i = $index) {
      <home-my-top-instrument-item data-zid="top-instrument-item" [item]="item" [index]="i" />
    }
  } @else {
    <div class="mb-2">{{ 'my-home.my-top-instruments.no-data' | transloco }}</div>
  }
}

@if (topInstrumentsSelector !== 'KRYPTO') {
  <a
    [routerLink]="tradableProductsPage"
    [queryParams]="{ type: searchType }"
    class="zero-text link p-small-med"
    data-zid="top-instrument-link"
  >
    {{ 'my-home.my-top-instruments.more.' + topInstrumentsSelector | transloco }}
  </a>
} @else {
  <a [routerLink]="cryptoOverviewPage" class="zero-text link p-small-med" data-zid="top-instrument-cryptolink">
    {{ 'my-home.my-top-instruments.more.' + topInstrumentsSelector | transloco }}
  </a>
}
